import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import CreateEnvelope from './pages/CreateEnvelope';
import ClaimEnvelope from './pages/ClaimEnvelope';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="app-header">
          <div className="header-container">
            <div className="header-logo">
              <h1>🔴 链上抢红包系统</h1>
            </div>
            <div className="header-actions">
              <ConnectButton />
            </div>
          </div>
        </header>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<CreateEnvelope />} />
          <Route path="/claim" element={<ClaimEnvelope />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
